;(function (angular, _) {
  'use strict'

  class LinkedInterventionsModalController {
    constructor (
      // Angular
      $q,
      // Libs
      // Managers
      EntityManager, InterventionManager,
      // Services
      SnackService
      // Const
      // Resolved
    ) {
      this.$q = $q
      this.entityManager = EntityManager
      this.interventionManager = InterventionManager
      this.snackService = SnackService
      this.interventions = []
      this.loading = false
      this.loaded = false
      this.error = false
    }

    $onInit () {
      const element = this.resolve.quote || this.resolve.invoice
      const source = _.get(element, 'linkedData.solica.interventions') || []

      // Les listes des factures et des devis n'envoient plus que des ids : on charge les interventions ici.
      // Des interventions déjà peuplées (autre appelant éventuel) sont gardées telles quelles.
      const alreadyPopulated = source.length && source.every((i) => i && typeof i === 'object')
      const promise = alreadyPopulated
        ? this.$q.resolve(source)
        : this._loadInterventions(source)

      this.loading = true
      promise
        .then((interventions) => {
          this.interventions = interventions.map((i) => {
            i.shippingEntity = this.entityManager.create(i.shippingEntity)
            return i
          })
        })
        .catch(() => {
          // En cas d'erreur on laisse la liste vide et on prévient l'utilisateur
          this.interventions = []
          this.error = true
          this.snackService.snack({
            text: 'Impossible de charger les interventions liées',
            delay: 10000,
            color: 'red',
            icon: 'mdi-alert-outline'
          })
        })
        .finally(() => {
          this.loading = false
          // La directive interventions-list ne lit ses données qu'à l'init : on ne l'affiche qu'une fois chargé
          this.loaded = true
        })
    }

    /**
     * Charge les interventions (archivées et supprimées comprises) à partir d'ids ou d'objets
     * @param {Array<String|Object>} interventions
     * @return {Promise<Array>} interventions peuplées, dans l'ordre d'origine
     * @private
     */
    _loadInterventions (interventions = []) {
      const ids = _.uniq(interventions
        .map((i) => typeof i === 'string' ? i : _.get(i, '_id'))
        .filter((id) => !!id))
      if (!ids.length) {
        return this.$q.resolve([])
      }
      // Mêmes champs que InterventionService.interventionEquipmentQuery (directive interventions-list)
      // On reproduit l'ancien populate : archivées ET supprimées (suppression logique) sont incluses.
      // ignoreArchived empêche le DAO d'ajouter isArchived/isDeleted aux conditions,
      // archived/deleted: 'both' empêchent l'API (restrict-post) d'ajouter ses filtres par défaut.
      // Le filtre company reste appliqué côté API (intervention.controller#filters).
      // limit explicite : l'API applique 100 par défaut sur /filters (pas de skip envoyé)
      const query = this.interventionManager.query({
        archived: 'both',
        deleted: 'both',
        limit: ids.length,
        populate: JSON.stringify([
          {
            path: 'technicians',
            select: 'firstname lastname fullname color'
          },
          {
            path: 'shippingEntity',
            model: 'Entity'
          }
        ])
      })
        .select(ids)
        .fields('title technicians shippingEntity realBeginAt realEndedAt status beginAt endedAt')
      return this.interventionManager.post(query, { ignoreArchived: true })
        .then(({ data }) => _.sortBy(data, (i) => ids.indexOf(i._id)))
    }
  }

  LinkedInterventionsModalController.$inject = [
    // Angular
    '$q',
    // Libs
    // Managers
    'EntityManager', 'InterventionManager',
    // Services
    'SnackService'
    // Const
    // Resolved
  ]

  angular.module('kilo.routes.invoice.list')
    .component('linkedInterventionsModal', {
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      templateUrl: '/app/modules/invoice/modals/linked-interventions-modal.template.html',
      controller: LinkedInterventionsModalController
    })

})(window.angular, window._)
